import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/StoreProvider";
import type { LoginCredentials, SignUpData } from "../types";

/**
 * Ações estáveis (useCallback) + leitura da AuthStore.
 * Componentes que renderizam `user`, `isLoggedIn`, etc. devem usar `observer` do mobx-react-lite.
 */
export const useAuth = () => {
  const authStore = useAuthStore();
  const navigate = useNavigate();

  const login = useCallback(
    async (credentials: LoginCredentials) => {
      await authStore.login(credentials);
    },
    [authStore],
  );

  const signUp = useCallback(
    async (data: SignUpData) => {
      await authStore.signUp(data);
    },
    [authStore],
  );

  const logout = useCallback(() => {
    authStore.logout();
    navigate("/login", { replace: true });
  }, [authStore, navigate]);

  return {
    isAuthenticated: authStore.isAuthenticated,
    user: authStore.user,
    token: authStore.accessToken,
    isLoggedIn: authStore.isLoggedIn,
    displayName: authStore.displayName,
    userEmail: authStore.userEmail,
    userType: authStore.userType,

    login,
    signUp,
    logout,
  };
};
